import { pageConst } from "@src/constants/pageConst";
import Head from "next/head";
import { useRouter } from "next/router";

/**
 * タイトルセット用injector
 * @returns {JSX.Element}
 * @constructor
 */
export function TitleInjector() {
  const router = useRouter();
  let title = "";
  Object.values(pageConst).map((page) => {
    if (page.href === router.pathname) {
      title = page.name + " | 大和証券";
    }
  });

  return (
    <Head>
      <title>{title}</title>
    </Head>
  );
}
